module.exports = __webpack_public_path__ + "media/images/autopilot/setup_step_2_wl-e1c0905802e7fb7add45ba7459be1c23.svg";